import React from 'react';
import '../../styles/CaseStudyOne/CaseStudiesBeginning.css';
import productIcon1 from '../../assets/ai-brain.png';
import productIcon2 from '../../assets/google-headset.png';
import productIcon3 from '../../assets/color-q.png';

const SectionBeginning = () => {
  return (
    <section className="beginning-section">
      <div className="beginning-container">
        {/* Title */}
        <h2 className="beginning-title">The Beginning</h2>

        {/* Product/Service Boxes */}
        <div className="product-service-container">
          <div className="product-service-box">
            <img src={productIcon1} alt="Product 1" className="beginning-product-icon" />
            <p>Call Tracking Metrics AskAI</p>
          </div>
          <div className="product-service-box">
            <img src={productIcon2} alt="Product 2" className="beginning-product-icon" />
            <p>Google PMAX Campaigns</p>
          </div>
          <div className="product-service-box">
            <img src={productIcon3} alt="Product 3" className="beginning-product-icon" />
            <p>Google Ads Search Optimization</p>
          </div>
        </div>

        {/* Description Text */}
        <p className="beginning-description">
          Before using Call Tracking Metrics' ASKAI feature in 2023, Bullfrog Pool Tile Cleaning faced challenges with their advertising strategy. The company,
          which specializes in pool tile cleaning in the greater Phoenix area, struggled to effectively measure conversions and optimize Google campaigns.
        </p>
        <p className="beginning-description">
          At the time, they were:
        </p>
        <ul className="beginning-description">
          <li>Only optimizing toward inbound calls</li>
          <li>Experiencing a cost per booked appointment of over $200</li>
          <li>Unable to leverage Google's Performance Max(PMAX) campaigns due to an influx of spam calls and form submissions</li>
        </ul>
        <p className="beginning-description">
          Without accurate call tracking and booked appointment data, their Google Ads campaigns lacked the efficiency and precision needed to scale and lower costs.
        </p>

      </div>
    </section>
  );
};

export default SectionBeginning;

